import { SxProps } from "@mui/material";

export const sxTypographyTitle: SxProps = {
  fontFamily: 'UnimedSans-Bold',
  textAlign: 'start',
  fontSize: '20px'
};

export const sxTextButton: SxProps = {
  fontFamily: 'UnimedSans-Bold',
  fontSize: 16
};

export const sxButton: SxProps = {
  borderRadius: 80,
  padding: '12px 32px',
  height: '44px',
  border: 2,
  '@media (max-width: 899px)': {
    width: 'stretch',
  }
};

export const sxButtonContained: SxProps = {
  borderRadius: 80,
  padding: '12px 32px',
  height: '44px',
  '@media (max-width: 899px)': {
    width: 'stretch',
  },
};

export const sxInputNumberModal: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
  '@media (max-width: 899px)': {
    maxWidth: 'unset'
  }
}